















import openApp from '@ivy/fts/openApp'
import store from '../store'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component

export default class IvyFooter extends Vue {
  @Prop({ default: false }) needFooter: boolean
  store: any = store
  noApp: any = store.noApp
  hasApp: any = null
  descText: any = store.fromQr ? '下载APP，获得更多优质启蒙资源' : '成为更好的父母' // 下载APP，获得更多国学启蒙内容
  callLib: any = null
  callUp() {
    return openApp('readtool')
  }
  hideBar() {
    // 隐藏/关闭浮动条
    // this.barShow = false
    store.footBarShow = false
  }
}
